var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.002 16.964a.5.5 0 1 0 .997.072l.5-7a.5.5 0 1 0-.998-.072zM8 17.036a.5.5 0 0 0 .997-.072l-.498-7a.5.5 0 0 0-.998.072zM11.5 17a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.943 5.5H21.5a.5.5 0 0 0 0-1h-5A2.5 2.5 0 0 0 14 2h-4a2.5 2.5 0 0 0-2.5 2.5h-5a.5.5 0 0 0 0 1h1.557l.835 14.614A2 2 0 0 0 6.89 22h10.222a2 2 0 0 0 1.997-1.886zM14 3a1.5 1.5 0 0 1 1.5 1.5h-7A1.5 1.5 0 0 1 10 3zM5.89 20.057 5.06 5.5H18.94l-.832 14.557a1 1 0 0 1-.998.943H6.889a1 1 0 0 1-.998-.943",
    clipRule: "evenodd"
  })));
};
export default SvgIconTrash;